const customDropdowns = document.querySelectorAll('.custom-dropdown');

customDropdowns.forEach((dropdown) => {
    const trigger = dropdown.querySelector('.dropdown-trigger');
    const options = dropdown.querySelector('.dropdown-options');
    const placeholder = dropdown.querySelector('.dropdown-placeholder');
    const chevron = dropdown.querySelector('.fas.fa-chevron-down');
    const optionItems = dropdown.querySelectorAll('.dropdown-option');

    trigger.addEventListener('click', (e) => {
        e.stopPropagation();

        customDropdowns.forEach((otherDropdown) => {
            if (otherDropdown !== dropdown) {
                otherDropdown
                    .querySelector('.dropdown-options')
                    .classList.add('hidden');
                otherDropdown
                    .querySelector('.fas.fa-chevron-down')
                    .classList.remove('rotate-180');
            }
        });

        options.classList.toggle('hidden');
        chevron.classList.toggle('rotate-180');
    });

    optionItems.forEach((option) => {
        option.addEventListener('click', (e) => {
            e.stopPropagation();

            const value = option.getAttribute('data-value');
            const text = option.textContent;

            placeholder.textContent = text;
            placeholder.classList.remove('text-gray-500');
            placeholder.classList.add('text-gray-900');

            dropdown.dataset.selectedValue = value;

            options.classList.add('hidden');
            chevron.classList.remove('rotate-180');

            dropdown.dispatchEvent(
                new CustomEvent('dropdownChange', {
                    detail: { value, text },
                })
            );
        });
    });

    document.addEventListener('click', (e) => {
        if (!dropdown.contains(e.target)) {
            options.classList.add('hidden');
            chevron.classList.remove('rotate-180');
        }
    });
});
